import Service from "../../../Services/index";
import moment from "moment";

const purchaseOrder = {
    namespaced: true,
    state: {
        table: [],
        data : [],
        get_all : [],
        purchase_not_rr : [],
        form:{
            vendor:null,
            date : "",
            details: [],
            user: "",
            status:"",
            po_number: "",
            discount: "",
            status_tax : "0"
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        search:{
            po_number:"",
            date:"",
            vendor:""
        },
    },
    mutations: {
        GET_PURCHASE_ORDER: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_PURCHASE_ORDER_BY_ID:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA: (state) => {
            const currentDate = moment().format("YYYY-MM-DD");
            state.form = {
                vendor:null,
                date : currentDate,
                details: [],
                user: "",
                status:"",
                po_number: "",
                discount: "",
                status_tax : "0"
            };
        },
        ADD_MATERIAL: (state, data) => {
            state.form.details = [
                ...state.form.details,
                {
                    ...data
                }
            ];
        },
        REMOVE_MATERIAL: (state, index) => {
            state.form.details = state.form.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                po_number:"",
                date:"",
                vendor:""
            }
        },
        GET_PURCHASE_NOT_RR :(state, res)=>{
            state.purchase_not_rr = res;
        },
        SET_PO_NUMBER:(state,res)=>{
            state.form.po_number = res;
        }
    },
    actions: {
        getVendorAll(){
            return Service.vendor.getVendorAll();
        },
        setPurchaseOrder({ commit },page=1) {
            return Service.PurchaseOrder.getPurchaseOrder(page).then(response => {
                commit("GET_PURCHASE_ORDER", response);
            });
        },
        createFromClick({commit},data) {
            return Service.PurchaseOrder.savePurchaseOrder(data);
        },

        createByForm({commit,state},{id,user}){
            let data = {
                po_number : state.form.po_number,
                user_id : user,
                user_update_id : '',
                vendor_id :state.form.vendor.id,
                date : state.form.date,
                status : 1,
                discount : 0,
                status_tax : state.form.status_tax,
                details: state.form.details.map(detail => ({
                    ...detail,
                    material_id: detail.material.id,
                }))
            };
            if(!id){ //create
                console.log(data);
                return Service.PurchaseOrder.createPurchaseOrder(data);
            }else{ //update
                console.log(data);
                data.po_number = state.form.po_number;
                data.status = state.form.status;
                data.discount = state.form.discount;
                data.user_update_id = user;
                return Service.PurchaseOrder.updatePurchaseOrder(id,data);
            }
        },
        show({commit},id){
            return Service.PurchaseOrder.showPurchaseOrder(id).then(response=>{
                commit("GET_PURCHASE_ORDER_BY_ID",response)
            })
        },
        update({commit},{id,data}){
            console.log(data);
            return Service.PurchaseOrder.updatePurchaseOrder(id,data);
        },
        delete({commit},id){
            return Service.PurchaseOrder.deletePurchaseOrder(id);
        },
        getAll({commit}){
           return Service.PurchaseOrder.getAllPurchaseOrder();
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        search({commit},{page="",po,date,vendor}){
            return Service.PurchaseOrder
                .searchPurchaseOrder(page,po,date,vendor)
                .then(data=>{
                    commit("GET_PURCHASE_ORDER",data)
                });
        },
        addMaterialDetail({ commit }, data) {
            commit("ADD_MATERIAL", data);
        },
        removeMaterial({ commit }, index) {
            commit("REMOVE_MATERIAL", index);
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        selectPurchaseOrderAll({commit},data){
            return Service.PurchaseOrder.selectPurchaseOrderAll(data)
        },
        getPurchaseOrderNotCreateRR({commit}){
            return Service.PurchaseOrder.getPurchaseOrderNotCreateRR().then(res=>{
                commit("GET_PURCHASE_NOT_RR",res);
            })
        },
        generatePO({state,commit},date) {
            return Service.PurchaseOrder.generatePO(date);
        }
    }
};

export default purchaseOrder;
